module.exports = __webpack_public_path__ + "static/img/logo.68261907.png";